import {
  DotsMessageSeverity,
  DotsToastMessage,
  DotsMessageVariant,
} from "dots-ui/dotsToast";

import { useMemo } from "react";
import { AvisDescriptiveText } from "../AvisDescriptiveText";

export interface IAvisToastMessageProps {
  severity?: DotsMessageSeverity;
  variant?: DotsMessageVariant;
  className?: string;
  textKey?: string;
  content?: React.ReactNode;
  visible?: boolean;
}
export function AvisToastMessage(props: Readonly<IAvisToastMessageProps>) {
  const {
    textKey,
    className,
    content,
    visible,
    severity = "primary",
    variant,
  } = props;

  const contentValue = useMemo(
    () => (textKey ? <AvisDescriptiveText textKey={textKey} /> : content),
    [content, textKey],
  );

  if (!visible) return null;

  return (
    <DotsToastMessage
      className={className}
      message={{
        severity: severity, // "primary" | "success" | "info" | "warning" | "danger"
        display: "inline",
        content: contentValue,
        variant: variant, // "outlined" | "filled"
      }}
    />
  );
}
